/***************************************************************************************************
 ** Disable Turbo Drive except for <a> tags
 ***************************************************************************************************/

import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false;

document.addEventListener("turbo:load", () => {
  for (const link of document.querySelectorAll("a")) {
    if (link.dataset.turbo !== "false") {
      link.setAttribute("data-turbo", "true");
    }
  }
});

/***************************************************************************************************
 ** Vendors
 ***************************************************************************************************/

// Active Storage (File uploads)
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

/***************************************************************************************************
 ** Stimulus
 ***************************************************************************************************/

import { Application } from "@hotwired/stimulus";
const application = Application.start();

import ModalController from "@controllers/modal_controller.js";
application.register("modal", ModalController);

import GenericFormController from "@controllers/generic_form_controller.js";
application.register("generic_form", GenericFormController);

/**************************************************************************************************/

import "@utils/turbo_stream_actions.js";

import "@javascript/client/pages.js";
